import { useQuery } from '@tanstack/react-query';
import { onboardingApis } from './api';

/** GET /onboarding/status - gate with `enabled` to Clinic Owner sessions only (403 otherwise). */
const useOnboardingStatus = ({ enabled = true } = {}) =>
  useQuery({
    queryKey: ['onboarding', 'status'],
    queryFn: () => onboardingApis.getOnboardingStatus(),
    enabled,
    retry: false,
  });

/**
 * GET /onboarding/patient - fetched fresh every time onboarding (re)starts at OB1, so nothing
 * from an interrupted run is reused.
 */
const usePatientOnboardingData = ({ enabled = true } = {}) =>
  useQuery({
    queryKey: ['onboarding', 'patient'],
    queryFn: () => onboardingApis.getPatientOnboarding(),
    enabled,
    retry: false,
    gcTime: 0,
  });

export const onboardingQueries = { useOnboardingStatus, usePatientOnboardingData };
